// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"u-","editButton":"u_","formClass":"va","rowClass":"vb","columnClass":"vc","inputClass":"vd","email":"ve","mobile":"vf","cancelButton":"vh","submitButton":"vi"};